import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { actionCreators as edgeActionCreators } from '../../../ducks/resource-edges';
import { actionCreators as nodeActionCreators } from '../../../ducks/resource-nodes';
import { uuidv4 } from '../../../../utils/uuid';

/** start resumable upload nested in a parentResource */

export const createNestedUpload = (
  file,
  parentResource: ResourceIdentifier,
  dispatch,
  assetLabel = 'assets',
  workspaceId
) => {
  // already add this upload resource to the parent folder
  // so we can show something as soon as the user drops the files
  dispatch(
    edgeActionCreators.receiveResourceEdges(
      parentResource.id,
      parentResource.type,
      'file-uploads',
      'file-upload',
      [
        {
          id: file.id,
          type: 'file-upload'
        }
      ],
      { merge: true }
    )
  );

  dispatch(
    edgeActionCreators.receiveResourceEdges(
      workspaceId,
      'workspace',
      'file-uploads',
      'file-upload',
      [
        {
          id: file.id,
          type: 'file-upload'
        }
      ],
      { merge: true }
    )
  );

  // legacy cube requires an asset to be created,
  // before we can upload something
  // The upload needs to pass along the asset ID in meta data
  // create-middleware handles this process for us by accepting files as
  // a parameter for creating an asset.
  dispatch(
    nodeActionCreators.createResourceByAncestor(
      'asset',
      uuidv4(),
      { display_name: file.name, file_size: file.size },
      parentResource.type,
      parentResource.id,
      assetLabel,
      [file],
      [{ type: 'workspace', id: workspaceId, relationship: 'search' }]
    )
  );
};
